import { PackagingLevel } from "../../shared/packaging";
import { useProcessGatePackagingMutations } from "../../shared/packaging/hooks/useProcessGatePackagingMutations";
import { PackagingLevelProps } from "../../shared/packaging/packagingLevel.types";

type ProcessGatePackagingProps = Omit<PackagingLevelProps, "gate" | "gateId" | "mutations"> & {
  processGateId: string;
};

const Packaging = ({ processGateId, ...props }: ProcessGatePackagingProps) => {
  const mutations = useProcessGatePackagingMutations();

  return (
    <PackagingLevel gate="process-gate" gateId={processGateId} mutations={mutations} {...props} />
  );
};

export default Packaging;
